import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyCjNAACkfeB-f6Z1jHTzbeIcl4gmpsnwZc',
  authDomain: 'golfsimgenie.firebaseapp.com',
  projectId: 'golfsimgenie',
  storageBucket: 'golfsimgenie.firebasestorage.app',
  messagingSenderId: '519662560351',
  appId: '1:519662560351:web:9fe0746468ffcc3f6ae7ea',
  measurementId: 'G-M0C40L2KRK',
};

export const firebaseApp = initializeApp(firebaseConfig);

export const db = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);
auth.setPersistence(browserLocalPersistence);
export const functions = getFunctions();

if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}
else if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'false') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}
